module.exports = __webpack_public_path__ + "app/principal/principal-header-info-2g5C5tPr.html";